export default "__VITE_ASSET__CeRgGjSu__"